<mat-toolbar color="primary">
    <button mat-icon-button (click)="sidenav.toggle()" matTooltip="Menu">
        <mat-icon>menu</mat-icon>
    </button>
    <h1 class="menu-titel" *ngIf="!isSignedIn" routerLink="" (click)="sidenav._closeViaBackdropClick()">EsportsMS</h1>
    <h1 class="menu-titel" *ngIf="isSignedIn && hasSubscription" [routerLink]="[currentWorkspaceID, 'dashboard']" (click)="sidenav._closeViaBackdropClick()">EsportsMS</h1>
    <h1 class="menu-titel" *ngIf="isSignedIn && !hasSubscription" routerLink="" (click)="sidenav._closeViaBackdropClick()">EsportsMS</h1>
    <div class="toolbar-spacer"></div>
    <button mat-icon-button [matMenuTriggerFor]="appMenu" matTooltip="LIUMEX-Apps">
        <mat-icon>apps</mat-icon>
    </button>
    <mat-menu #appMenu="matMenu" class="app-menu">
        <span *ngFor="let extService of extServices">
            <a *ngIf="extService.available" target="_blank" href="{{ extService.url }}">
                <button mat-menu-item>
                    <div class="logo-container">
                        <img [src]="extService.logo">
                    </div>    
                    <span>{{ extService.name }}</span>
                </button>
            </a>
        </span>
    </mat-menu>
    <button mat-raised-button *ngIf="!isSignedIn" (click)="signIn()" color="accent">Sign In</button>
    <div *ngIf="isSignedIn" class="account-menu-button">
        <img [matMenuTriggerFor]="accountMenu" [src]="profilePicture">
        <mat-icon *ngIf="isAdmin || isSupport" [matMenuTriggerFor]="accountMenu" matTooltip="Staff" matTooltipPosition="before">token</mat-icon>
        <mat-icon *ngIf="isPartner && !isAdmin && !isSupport" [matMenuTriggerFor]="accountMenu" matTooltip="Partner" matTooltipPosition="before">verified</mat-icon>
        <mat-icon *ngIf="isPremium && !isPartner && !isAdmin && !isSupport"[matMenuTriggerFor]="accountMenu" matTooltip="Premium" matTooltipPosition="before">workspace_premium</mat-icon>        
    </div>
    <mat-menu #accountMenu="matMenu" class="account-menu">
        <div class="account-info" (click)="$event.stopPropagation()">
            <img [src]="profilePicture">
            <p>{{ username }}</p>
        </div>
        <!-- Disable Theme Toggle -->
        <!-- <div class="theme-toggle" (click)="toggleTheme()">
            <mat-slide-toggle [checked]="isDarkThemeOn" color="accent" class="icon-slide-toggle"></mat-slide-toggle>
            <p *ngIf="!isDarkThemeOn">Light Mode</p>
            <p *ngIf="isDarkThemeOn">Dark Mode</p>
        </div> -->
        <a target="_blank" href="https://account.liumex.com/auth">
            <button mat-menu-item>
                <mat-icon>manage_accounts</mat-icon>
                <span>Edit Account</span>
            </button>
        </a>
        <a *ngIf="isAdmin || isSupport" target="_blank" href="https://admin.liumex.com/">
            <button mat-menu-item>
                <mat-icon>settings</mat-icon>
                <span>Admin Panel</span>
            </button>
        </a>
        <button mat-menu-item (click)="signOut(); sidenav._closeViaBackdropClick()">
            <mat-icon>logout</mat-icon>
            <span>Sign Out</span>
        </button>
    </mat-menu>
</mat-toolbar>
<mat-sidenav-container>
    <mat-sidenav #sidenav id="sidenav" mode="over" autoFocus="false">
        <mat-nav-list>
            <a mat-list-item routerLink="veto" (click)="sidenav._closeViaBackdropClick()">
                <mat-icon>login</mat-icon><span>Join - Map Veto</span>
            </a>
            <!-- <a mat-list-item routerLink="features" *ngIf="!isSignedIn" (click)="sidenav._closeViaBackdropClick()">
                <mat-icon>widgets</mat-icon><span>Features</span>
            </a> -->
            <mat-form-field *ngIf="isSignedIn" subscriptSizing="dynamic">
                <mat-label>Workspace</mat-label>
                <mat-select (selectionChange)="changeWorkspace($event)" [value]="workspaceDropdown">
                    <mat-option *ngFor="let emsWorkspaceInfo of emsWorkspaces" [value]="emsWorkspaceInfo.uid">{{ emsWorkspaceInfo.name }}</mat-option>
                </mat-select>
            </mat-form-field>
            <!-- <a mat-list-item routerLink="features" *ngIf="isSignedIn && (workspaceDropdown == '#' || workspaceDropdown == '')" (click)="sidenav._closeViaBackdropClick()">
                <mat-icon>widgets</mat-icon><span>Features</span>
            </a> -->
            <a mat-list-item target="_blank" href="https://liumex.com/contact" *ngIf="isSignedIn && (workspaceDropdown == '#' || workspaceDropdown == '')" (click)="sidenav.toggle()">
                <mat-icon>mail</mat-icon><span>Contact</span>
            </a>
            <mat-expansion-panel *ngIf="isSignedIn && currentWorkspaceID && hasSubscription && hasStageEnabled" #competitionsPanel hideToggle>
                <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
                    <mat-panel-title>
                        <mat-icon>stadium</mat-icon><span>Virtual Stage</span>
                   </mat-panel-title>
                   <mat-icon>{{competitionsPanel.expanded? 'expand_more' : 'expand_less'}}</mat-icon>
                </mat-expansion-panel-header>
                <mat-nav-list>
                    <a mat-list-item [routerLink]="[currentWorkspaceID, 'stage']" *ngIf="isSignedIn && currentWorkspaceID && hasSubscription  && hasStageEnabled" (click)="sidenav._closeViaBackdropClick()">
                        <span><mat-icon>desk</mat-icon>Stage</span>
                    </a>
                    <a mat-list-item [routerLink]="[currentWorkspaceID, 's', 'schedule']" *ngIf="isSignedIn && currentWorkspaceID && hasSubscription  && hasStageEnabled" (click)="sidenav._closeViaBackdropClick()">
                        <span><mat-icon>schedule</mat-icon>Schedule</span>
                    </a>
                    <a mat-list-item [routerLink]="[currentWorkspaceID, 'referee']" *ngIf="isSignedIn && currentWorkspaceID && hasSubscription  && hasStageEnabled" (click)="sidenav._closeViaBackdropClick()">
                        <span><mat-icon>sports</mat-icon>Referee</span>
                    </a>
                </mat-nav-list>
            </mat-expansion-panel>
            <mat-spinner *ngIf="isSignedIn && isLoadingEmsWorkspaceIDs"></mat-spinner>
            <mat-expansion-panel *ngIf="isSignedIn && currentWorkspaceID && hasSubscription && hasStageEnabled" #vetoPanel hideToggle>
                <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
                    <mat-panel-title>
                        <mat-icon>how_to_vote</mat-icon><span>Map Vetos</span>
                   </mat-panel-title>
                   <mat-icon>{{vetoPanel.expanded? 'expand_more' : 'expand_less'}}</mat-icon>
                </mat-expansion-panel-header>
                <mat-nav-list>
                    <a mat-list-item [routerLink]="[currentWorkspaceID, 'v', 'create']" (click)="sidenav._closeViaBackdropClick()">
                        <span><mat-icon>add_box</mat-icon>Create Veto</span>
                    </a>
                    <a mat-list-item [routerLink]="[currentWorkspaceID, 'v', 'list']" (click)="sidenav._closeViaBackdropClick()">
                        <span><mat-icon>assignment</mat-icon>List</span>
                    </a>
                    <!-- <a mat-list-item [routerLink]="[currentWorkspaceID, 'v', 'settings']" (click)="sidenav._closeViaBackdropClick()">
                        <span><mat-icon>settings</mat-icon>Settings</span>
                    </a> -->
                </mat-nav-list>
            </mat-expansion-panel>
            <mat-expansion-panel *ngIf="isSignedIn && currentWorkspaceID && hasSubscription && hasStageEnabled" #competitionsPanel hideToggle>
                <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
                    <mat-panel-title>
                        <mat-icon>gamepad</mat-icon><span>Competitions</span>
                   </mat-panel-title>
                   <mat-icon>{{competitionsPanel.expanded? 'expand_more' : 'expand_less'}}</mat-icon>
                </mat-expansion-panel-header>
                <mat-nav-list>
                    <a mat-list-item [routerLink]="[currentWorkspaceID, 'c', 'create']" (click)="sidenav._closeViaBackdropClick()">
                        <span><mat-icon>add_box</mat-icon>Create Competition</span>
                    </a>
                    <a mat-list-item *ngFor="let competition of competitions" [routerLink]="[currentWorkspaceID, 'c', competition.uid]" (click)="sidenav._closeViaBackdropClick()">
                        <span><img [src]="competition.logo">{{ competition.name }}</span>
                    </a>
                </mat-nav-list>
            </mat-expansion-panel>
            <mat-expansion-panel *ngIf="isSignedIn && currentWorkspaceID && hasSubscription  && hasStageEnabled" #teamsPanel hideToggle>
                <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
                    <mat-panel-title>
                        <mat-icon>groups</mat-icon><span>Teams</span>
                   </mat-panel-title>
                   <mat-icon>{{teamsPanel.expanded? 'expand_more' : 'expand_less'}}</mat-icon>
                </mat-expansion-panel-header>
                <mat-nav-list>
                    <a mat-list-item [routerLink]="[currentWorkspaceID, 't', 'create']" (click)="sidenav._closeViaBackdropClick()">
                        <span><mat-icon>add_box</mat-icon>Create Team</span>
                    </a>
                </mat-nav-list>
                <mat-expansion-panel *ngFor="let competition of competitions" #teamsCompPanel hideToggle>
                    <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'" class="submenu-header">
                        <mat-panel-title>
                            <span><img [src]="competition.logo">{{ competition.name }}</span>
                    </mat-panel-title>
                    <mat-icon>{{teamsCompPanel.expanded? 'expand_more' : 'expand_less'}}</mat-icon>
                    </mat-expansion-panel-header>
                    <mat-nav-list>
                        <ng-container *ngFor="let team of teams">
                            <a mat-list-item *ngIf="team.competition == competition.uid" [routerLink]="[currentWorkspaceID, 't', team.uid]" (click)="sidenav._closeViaBackdropClick()">
                                <span><img [src]="team.logo">{{ team.name }}</span>
                            </a>
                        </ng-container>
                    </mat-nav-list>
                </mat-expansion-panel>
            </mat-expansion-panel>
            <mat-expansion-panel *ngIf="isSignedIn && currentWorkspaceID && hasSubscription && hasBadgesEnabled" #integrationsPanel hideToggle>
                <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
                    <mat-panel-title>
                        <mat-icon>badge</mat-icon><span>Badges</span>
                   </mat-panel-title>
                   <mat-icon>{{integrationsPanel.expanded? 'expand_more' : 'expand_less'}}</mat-icon>
                </mat-expansion-panel-header>
                <mat-nav-list>
                    <a mat-list-item [routerLink]="[currentWorkspaceID, 'b', 'registry']" (click)="sidenav._closeViaBackdropClick()">
                        <span><mat-icon>numbers</mat-icon>Registry</span>
                    </a>
                    <a mat-list-item [routerLink]="[currentWorkspaceID, 'b', 'meal-counter']" (click)="sidenav._closeViaBackdropClick()">
                        <span><mat-icon>fastfood</mat-icon>Meal Counter</span>
                    </a>
                    <a mat-list-item href="/{{currentWorkspaceID}}/external/meal-counter" target="_blank" (click)="sidenav._closeViaBackdropClick()">
                        <span><mat-icon>link</mat-icon>Meal Counter - External</span>
                    </a>
                </mat-nav-list>
            </mat-expansion-panel>   
            <a mat-list-item [routerLink]="[currentWorkspaceID, 'settings']" *ngIf="isSignedIn && currentWorkspaceID" (click)="sidenav._closeViaBackdropClick()">
                <mat-icon>settings</mat-icon><span>Settings</span>
            </a>
            <mat-divider></mat-divider>
            <a mat-list-item (click)="createWorkspace()">
                <mat-icon>create_new_folder</mat-icon><span>Create Workspace</span>
            </a>
        </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
        <div class="site-container">
            <div class="site-content">
                <div class="site-loading-spinner" *ngIf="isLoading | async"><mat-spinner></mat-spinner></div>
                <router-outlet></router-outlet>
            </div>
            <app-footer></app-footer>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container> 